interface Tagged {
  tags?: string[] | null;
}

export function tagsOf(item: Tagged): string[] {
  return item.tags ?? [];
}

export function distinctTags(items: Tagged[]): string[] {
  const byKey = new Map<string, string>();
  for (const item of items) {
    for (const tag of tagsOf(item)) {
      const key = tag.toLowerCase();
      if (!byKey.has(key)) {
        byKey.set(key, tag);
      }
    }
  }
  return [...byKey.values()].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' }),
  );
}

export function hasAnyTag(tags: string[], wanted: string[]): boolean {
  if (wanted.length === 0) {
    return true;
  }
  const own = new Set(tags.map((tag) => tag.toLowerCase()));
  return wanted.some((tag) => own.has(tag.toLowerCase()));
}
